/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {suggestedRecipients} from '../api'

export const useMutationSuggestedRecipients = createReactQueryMutationHook('suggestedRecipients', suggestedRecipients)
